// 共通メソッド
export default {
  methods: {
    // タイムスタンプを日付にフォーマット
    formatDate(_timestamp) {
      let _d = _timestamp ? new Date(_timestamp * 1000) : new Date()

      let Y = _d.getFullYear()
      let m = ('0' + (_d.getMonth() + 1)).slice(-2)
      let d = ('0' + _d.getDate()).slice(-2)
      let H = ('0' + _d.getHours()).slice(-2)
      let i = ('0' + _d.getMinutes()).slice(-2)
      let s = ('0' + _d.getSeconds()).slice(-2)

      return `${Y}/${m}/${d} ${H}:${i}:${s}`
    },
    // 日付をタイムスタンプにフォーマット
    formatTimestamp(_date) {
      let _d = _date ? new Date(_date) : null
      return _d && !isNaN(_d) ? Math.floor(_d.getTime() / 1000) : null
    },
    // 全角数字を半角数字に変換する
    toHalfWidthNumber(str) {
      return str.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
      })
    },
    // 空の配列かチェックして、空の場合はオブジェクトを返す
    emptyArrayToObject(data) {
      return Array.isArray(data) && data.length === 0 ? {} : data
    },
    // ひらがなをカタカナに変換する
    convertKana(str) {
      return str.replace(/[\u3041-\u3096]/g, function(match) {
        let chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    // 改行をhtmlに変換する
    convertBr(str) {
      if (str) {
        str = str.replace(/\r\n/g, '<br />')
        str = str.replace(/(\n|\r)/g, '<br />')
      }
      return str
    },
    // テキストが空の場合、- を表示
    formatText(text) {
      return text === '' || !text ? '-' : text
    },
    // 数字をカンマ区切り表示
    formatNumber(value) {
      let num = value
      if (_.isNull(value)) num = '-'
      if (value === '') num = '-'
      if (_.isNumber(value)) num = value.toLocaleString()
      return num
    },
  },
}
